<template>
  <label
    class="cac-input-wrapper" >
    <div class="cac-input-wrapper__title">
      <span class="cac-input-wrapper__span">
        {{ title }}
      </span>
      <div
        v-if="infoText"
        class="cac-input-wrapper__icon">
        <cac-tooltip
          :label="infoText"
          :large="infoLarge"
          position="top-right">
          <icon
            :icon-description="infoText"
            :icon-name="infoIcon"
            class="ml-2"
            view-box="0 0 16 16"
          />
        </cac-tooltip>
      </div>
    </div>
    <slot/>
  </label>
</template>

<script>
import CacTooltip from "CivicActionCenterComponents/utilities/CACTooltip.vue";

import Icon from "StyleguideComponents/Icon.vue";
import { INFO } from "Constants/styleguide/iconNames";

export default {
  name: "CACInputWrapper",
  components: {
    CacTooltip,
    Icon
  },
  props: {
    title: {
      type: String,
      required: true
    },
    infoText: {
      type: String,
      required: false,
      default: ""
    },
    infoLarge: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      infoIcon: INFO
    };
  }
};
</script>
